/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mucus.reducer';

export const MucusDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mucusEntity = useAppSelector(state => state.mucus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mucusDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mucus.detail.title">Mucus</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mucus.id">Id</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.id}</dd>
          <dt>
            <span id="feeling">
              <Translate contentKey="tinyMedicRestApp.mucus.feeling">Feeling</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.feeling}</dd>
          <dt>
            <span id="texture">
              <Translate contentKey="tinyMedicRestApp.mucus.texture">Texture</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.texture}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.mucus.value">Value</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.value}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.mucus.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mucus.active">Active</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.mucus.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.mucus.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.mucus.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.mucus.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.mucus.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.timestampEntry}</dd>
          <dt>
            <span id="isPresent">
              <Translate contentKey="tinyMedicRestApp.mucus.isPresent">Is Present</Translate>
            </span>
          </dt>
          <dd>{mucusEntity.isPresent ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mucus.cycleDay">Cycle Day</Translate>
          </dt>
          <dd>{mucusEntity.cycleDay ? mucusEntity.cycleDay.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/mucus" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/mucus/${mucusEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MucusDetail;
